import React from 'react';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import WhyChooseUs from '../components/WhyChooseUs';
import ContactCTA from '../components/ContactCTA';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <WhyChooseUs />
      <ServicesSection />
      <AboutSection />
      <ContactCTA />
    </div>
  );
};

export default Home;
